import Contact from "../components/Contact";


const ContactView = () => {

    return (
        <div className="contact">
            <Contact/>
        </div>
    );
};

export default ContactView;